var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        attrs: { content: "Información de Dirección", "has-line": true }
      }),
      _c(
        "div",
        { staticClass: "address-information-list mt-3" },
        [
          _vm._l(_vm.value, function(address, idx) {
            return _c(
              "custom-callout",
              {
                key: idx,
                staticClass: "mb-2",
                attrs: {
                  "show-edition":
                    !_vm.disabled &&
                    _vm.editMode &&
                    _vm.editInfo.data != null &&
                    _vm.editInfo.index == idx
                },
                scopedSlots: _vm._u(
                  [
                    _vm.editMode && _vm.editInfo.index == idx
                      ? {
                          key: "edition",
                          fn: function() {
                            return [
                              _c("address-information-add-edit", {
                                attrs: {
                                  "address-types": _vm.availableAddressTypes,
                                  "disable-primary": _vm.value.length < 2,
                                  "fiscal-year-id": _vm.fiscalYearId
                                },
                                on: {
                                  "on-cancel": _vm.onAddressCanceled,
                                  "on-saved": _vm.onAddressSaved
                                },
                                model: {
                                  value: _vm.editInfo.data,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editInfo, "data", $$v)
                                  },
                                  expression: "editInfo.data"
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      : null
                  ],
                  null,
                  true
                )
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-1 text-center align-middle mt-3" },
                    [
                      _c(
                        "div",
                        { staticClass: "dot text-center color-white" },
                        [_c("i", { staticClass: "fas fa-map-marker-alt" })]
                      )
                    ]
                  ),
                  _c("div", { staticClass: "col-sm-2 cell" }, [
                    _c("div", { staticClass: "data" }, [
                      _c("span", [_vm._v("Tipo:")]),
                      _c("p", [
                        _vm._v(
                          " " +
                            _vm._s(
                              address.addressTypeName == "Físico"
                                ? "Física"
                                : address.addressTypeName
                            ) +
                            " "
                        )
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "col-sm-6 cell" }, [
                    _c("div", { staticClass: "data" }, [
                      _c("span", [
                        _vm._v(
                          " Dirección " +
                            _vm._s(
                              address.addressTypeName == "Físico"
                                ? "Física"
                                : address.addressTypeName
                            ) +
                            ": "
                        )
                      ]),
                      _c("p", [_vm._v(_vm._s(_vm.addressFormat(address)))])
                    ])
                  ]),
                  !_vm.disabled && _vm.canPerformActions
                    ? _c(
                        "div",
                        { staticClass: "col-sm cell actions" },
                        [
                          _c("drop-down", {
                            attrs: {
                              "data-item": idx,
                              items: _vm.getAvailableActions(address)
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            )
          }),
          _c("custom-callout", {
            staticClass: "mb-2",
            attrs: {
              "show-container": false,
              "show-edition": !_vm.disabled && _vm.createMode
            },
            scopedSlots: _vm._u([
              {
                key: "edition",
                fn: function() {
                  return [
                    _c("address-information-add-edit", {
                      attrs: {
                        "address-types": _vm.availableAddressTypes,
                        "disable-primary": _vm.value.length == 0,
                        "fiscal-year-id": _vm.fiscalYearId
                      },
                      on: {
                        "on-cancel": _vm.onAddressCanceled,
                        "on-saved": _vm.onAddressSaved
                      },
                      model: {
                        value: _vm.editInfo.data,
                        callback: function($$v) {
                          _vm.$set(_vm.editInfo, "data", $$v)
                        },
                        expression: "editInfo.data"
                      }
                    })
                  ]
                },
                proxy: true
              }
            ])
          }),
          !_vm.disabled
            ? _c("div", { staticClass: "row mt-3" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _vm.editInfo.data == null && _vm.canAddAddress
                      ? _c("action-button", {
                          staticClass: "float-right",
                          attrs: {
                            i: "fas fa-plus",
                            text: "Añadir",
                            variant: "success"
                          },
                          on: { click: _vm.newAddress }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }